export default __webpack_public_path__ + "static/media/1.a9e06e90.png";